module.exports = __webpack_public_path__ + "img/23.f7c9a770.jpg";